import { Chip } from "@mui/material";
import { LAB_STATUS_COLORS, LAB_STATUS_LABELS } from "utils/externalLabRules";

const ExternalLabStatusChip = ({ status }) => (
  <Chip
    size="small"
    label={LAB_STATUS_LABELS[status] || status || "—"}
    data-testid="lab-status-chip"
    sx={{
      height: 22,
      fontSize: 11,
      fontWeight: 700,
      ...(LAB_STATUS_COLORS[status] || { bgcolor: "#F3F4F6", color: "#6B7280" }),
    }}
  />
);

export default ExternalLabStatusChip;
